import SideBar from "./SideBar";
export default function Home() {
  return (
    <div>
      {/* assign book module */}
      <div>
        {" "}
        <section className="class_room_wrap">
          <div className="custom_container">
            <div className="row">
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-12 px-0 left_side_bar  pb-0">
                <SideBar />
              </div>
              <div className="col-xxl-9 col-xl-9 col-lg-12  ">
                <h1>Welcome to Home Page!</h1>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Modal --> */}
        <div
          className="modal fade custom_moda_not"
          id="Not_yet"
          tabindex="-1"
          aria-labelledby="Not_yetLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button
                type="button"
                className="btn_close_modal"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src="assets/images/cross.png" alt="cross" />
              </button>
              <div className="modal-body modal_content_main_Wrap">
                <div className="modal_content_box">
                  <h1>Not yet!</h1>
                  <p>
                    Complete signup to see assignments, read the book and
                    connect with students in your class
                  </p>
                </div>
                <div className="btn_wrap_info">
                  <button type="button" className="btn_black_theme">
                    Take me back to signup
                  </button>
                  <button type="button" className="btn_outline_dark mt_24">
                    I just want to read
                  </button>
                </div>
              </div>
              <img
                src="assets/images/book.png"
                alt="book"
                className="book_img"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Assing book module */}
    </div>
  );
}
